import { IonCard, IonCardContent } from "@ionic/react";
import React from "react";

interface props {
	errors: any;
}

const EntryErrors: React.FC<props> = ({ errors }) => {
	return (
		<>
			{Object.values(errors).length > 0 && (
				<IonCard color="danger">
					<IonCardContent>
						<div id="errors">
							{Object.values(errors).map((error: any, idx: any) => (
								<div key={idx}>{error}</div>
							))}
						</div>
					</IonCardContent>
				</IonCard>
			)}
		</>
	);
};

export default EntryErrors;
